import React from "react";
import { Formik, FormikProps } from "formik";
import { Values } from "@src/Tools/Values";
import { Grid } from "@material-ui/core";
import { IValuesStore } from "@src/Stores/Values/types";
import _ from "lodash";
import { inject } from "mobx-react";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButton, STMcWebhook, STMcWebhookList, STNonPrimaryMcWebhookList } from "./styles";
import STPageSubTitle from "@src/Components/Ui/STPageSubTitle";
import { IOptions, IOptionsWebhook } from "@src/Interfaces/Entity/Options";
import { Components as MaranicsWC } from "@remotecloud/web-component-webhook/dist/types/components";
import { IWebhook, IItem } from "@remotecloud/web-component-webhook/dist/types/global/interfaces";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  initialValues: IOptions;
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
export default class WebhooksForm extends React.Component<IProps> {
  public wcCreateRef: React.RefObject<WebComponentType<MaranicsWC.McWebhook>> = React.createRef();
  public wcListRef: React.RefObject<WebComponentType<MaranicsWC.McWebhookList>> = React.createRef();

  handleSubmit = async (values: IOptions) => {
    let result: IOptions = Object.assign({}, values);
    result.webhooks = this.wcListRef.current.webhookList
      .map((entry: IWebhook): IOptionsWebhook => {
        return {
          action: entry.Action.Id,
          entity: entry.Entity.Id,
          url: entry.WebhookUrl
        };
      });
    await this.props.management.saveOptions(result);
  };

  async componentDidMount() {
    await this.wcCreateRef.current.componentOnReady();
    await this.wcListRef.current.componentOnReady();
        
    this.wcCreateRef.current.entityOptions = Object
      .entries(this.props.values.webhookEntities)
      .map((entry: [string, string]) => {
        const [name, type] = entry;
        return { Id: type, Name: name };
      });

    this.wcCreateRef.current.actionOptions = Object
      .entries(this.props.values.webhookActions)
      .map((entry: [string, number]) => {
        const [name, id] = entry;
        return { Id: id, Name: name };
      });

    this.wcListRef.current.webhookList = this.props.management.options.webhooks
      .map((entry: IOptionsWebhook, i: number): IWebhook => {
        let entity = this.wcCreateRef.current.entityOptions.find((x: IItem) => x.Id === entry.entity);
        let action = this.wcCreateRef.current.actionOptions.find((x: IItem) => x.Id === entry.action);
        return {
          Entity: entity,
          Action: action,
          WebhookUrl: entry.url,
          WebhookId: i.toString()
        };
      });

    this.wcCreateRef.current.addEventListener("webhookCreated", (event: CustomEvent) => {
        let existingItem = _.find(this.wcListRef.current.webhookList, {
          WebhookUrl: event.detail.WebhookUrl,
          Entity: event.detail.Entity,
          Action: event.detail.Action
        });
        if (existingItem) {
          _.pull(this.wcListRef.current.webhookList, existingItem)
        }
        this.wcListRef.current.webhookList = [...this.wcListRef.current.webhookList, event.detail];
      }
    );
  }  

  componentWillUnmount() {
    this.wcCreateRef.current.removeEventListener("webhookCreated", () => null as any);
  }

  render() {
    return (
      <Formik
        initialValues={this.props.initialValues}
        onSubmit={this.handleSubmit}
        render={(formikProps: FormikProps<IOptions>) => (
          <form onSubmit={formikProps.handleSubmit}>
            <STMcWebhook style={ this.props.auth.user.location.primary ? {} : { display: 'none' } }>
              <mc-webhook ref={this.wcCreateRef}></mc-webhook>
            </STMcWebhook>
            <STPageSubTitle>
              {Values.getLocalizationValue("webhookList")}
            </STPageSubTitle>

            {this.props.auth.user.location.primary
              ? (<STMcWebhookList>
                  <mc-webhook-list ref={this.wcListRef}></mc-webhook-list>
                </STMcWebhookList>)
              : (<STNonPrimaryMcWebhookList>
                <mc-webhook-list ref={this.wcListRef}></mc-webhook-list>
                </STNonPrimaryMcWebhookList>)}

            <Grid container justify="center">
              {this.props.auth.user.location.primary && (
                <STButton type="submit" variant="contained" color="primary">
                  {Values.getLocalizationValue("update")}
                </STButton>
              )}
            </Grid>

          </form>
        )}
      />
    );
  }
}
